import React from 'react';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

function LittleAngels() {
  return (
    <section className='giving ptb-50'>
      <div className='container'>
        <div className='row'>
          <div className='col-md-12'>
            <div className='sec-heading'>
              <h2>OUR LITTLE ANGELS</h2>
            </div>
          </div>
        </div>
        <div className='main-giving'>
          <div className='row items-center'>
            <div className='col-md-4 mx-auto'>
              <div className='little-angel-card'>
                <div className='angel-card-inside-box'>
                  <div className='angel-card-featured-img'>
                    <img src='/assets/images/moksh.jpeg' alt='' />
                  </div>
                  <div className='angel-card-content'>
                    <div className='footer-flex'>
                      <Link to='/our-little-angels'>
                        <div className='little-angel-title'>Moksh Kumar</div>
                      </Link>
                      <div className='little-angel-age'>5 Years</div>
                    </div>
                    <div className='little-angel-disease'>
                      <p>Blood Cancer (B-ALL)</p>
                    </div>
                    <div className='little-angel-heading'>
                      <p>
                        <strong>Forever in Our Hearts – Moksh Kumar</strong>
                      </p>
                    </div>
                    <div className='little-angel-short_desc'>
                      <p>
                        In a heartbreaking turn of events, we received the
                        devastating news that 5-year-old Moksh Kumar, who was
                        bravely fighting Blood Cancer (B-ALL), is no longer with
                        us.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='col-md-6 align-center little-angel-pt-24'>
              <div className='logo-image'>
                <img src='assets/images/logo.png' />
                <h2>A Tribute to our Brave Souls.</h2>
              </div>

              <div className='little-angels-para pt-2'>
                <p>
                  In the memory of our brave souls who fought till the last
                  breath. Kids, you will always be in our hearts. We hope you
                  are in a better place. We will forever cherish the moment
                  spent together. Adios.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default LittleAngels;
